import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SizeMe } from 'react-sizeme';
import Box from '../../shared/Box';
import Text from '../../shared/Text';
import Icon from '../../shared/Icon';
import { LinkText } from '../../shared/Link';
import Image from '../../shared/Image';
import Heading from '../../shared/Heading';
import ScreenSection from '../../shared/ScreenSection';

import ImportForm from './components/ImportForm';
import TypeaheadOption from './components/TypeaheadOption';
import ConfirmationModal from './components/ConfirmationModal';
import { Footer } from '../../components/Footer';

// TODO: This Screen should be broken into multiple components.

// TODO: These shouldn't be in this file.
const valueProps = [
  'Unlimited free hosting and distribution',
  'Upload your podcast or use our creation tools',
  'Take voice messages from fans and easily incorporate them into your podcast',
  'Track performance with cross-platform analytics',
  'Non-exclusive license allows you to own your content with no contracts',
  <Text size="lg" color="rgba(41, 47, 54, 0.6)">
    <LinkText isInline to="/sponsorships">
      Monetization options
    </LinkText>{' '}
    you won’t find anywhere else
  </Text>,
];

// TODO: These shouldn't be in this file.
const stepsToSwitch = [
  {
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/import.png',
    retinaImageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/import@2x.png',
    title: 'Import to Anchor',
    description:
      'It only takes a second to import your episodes; no manual uploading required.',
  },
  {
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/redirect.png',
    retinaImageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/redirect@2x.png',
    title: 'Redirect your old feed',
    description:
      "This way, your listeners will be able to hear your new episodes. This won't impact your existing listing, reviews, or subscribers.",
  },
  {
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/thats_it.png',
    retinaImageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/thats_it@2x.png',
    title: "That's it!",
    description:
      'Start making your future episodes with Anchor. Either upload your audio as-is or use our built-in tools to edit.',
  },
];

// TODO: These shouldn't be in this file.
const faqs = [
  {
    question: 'Is Anchor really free? How is that possible?',
    renderAnswer: () => (
      <Text size="xl" align="left" color="#ffffff">
        We don’t believe in charging creators to store their work. Our platform
        helps podcasters monetize their work, and we take an industry-smallest
        cut of the revenue to make sure we can keep building the best product
        possible, for free.
      </Text>
    ),
  },
  {
    question: 'Who owns the rights to my content if I use Anchor?',
    renderAnswer: () => (
      <Text size="xl" align="left" color="#ffffff">
        You do, 100%. Creators on Anchor always have and always will own their
        content. If you’re curious about our license for hosting and
        distributing your podcast, full details can be found in our Terms of
        Service{' '}
        <LinkText to="/tos" isInline>
          <Text size="xl" color="#ffffff" isInline isBold>
            here.
          </Text>
        </LinkText>
      </Text>
    ),
  },
  {
    question: 'How exactly does distribution work?',
    renderAnswer: () => (
      <Box>
        <Box>
          <Text size="xl" align="left" color="#ffffff">
            Anchor submits your RSS feed automatically to all major listening
            platforms, including Apple Podcasts, Google Podcasts, Spotify and{' '}
            <LinkText to="http://anch.co/distribution" isInline>
              <Text size="xl" color="#ffffff" isInline isBold>
                many more
              </Text>
            </LinkText>
            . All it takes from you is one click; we handle everything else. For
            any platforms where you already have a presence, we’ll link those
            accounts to make sure there are no duplicates and your fans won't
            see any changes.
          </Text>
        </Box>
        <Box marginTop={20}>
          <Text size="xl" align="left" color="#ffffff">
            Prefer to manage your RSS feed and handle distribution yourself? No
            problem. Our One-Click Distribution is completely optional.
          </Text>
        </Box>
      </Box>
    ),
  },
  {
    question: 'What if I change my mind about switching to Anchor?',
    renderAnswer: () => (
      <Text size="xl" align="left" color="#ffffff">
        Importing your episodes to Anchor doesn't affect your RSS feed; the
        switch only happens when you redirect. So you'll have plenty of time to
        click around and make sure Anchor is the right platform for you before
        officially switching. And, if you find that Anchor isn't as amazing as
        you thought it would be, you can easily switch back at any time.
      </Text>
    ),
  },
  {
    question: 'Will my podcast be unavailable during the switching process?',
    renderAnswer: () => (
      <Text size="xl" align="left" color="#ffffff">
        There's zero down time during switching. Redirecting your feed from your
        old host to Anchor is instant, so you don't have to worry about anyone
        being unable to access your podcast. The whole process of switching will
        only take you a few minutes and it happens completely behind the scenes,
        so it won't have any impact on your listing or your subscribers.
      </Text>
    ),
  },
  {
    question:
      'Do I have to use Anchor’s creation tools or can I upload my own finished audio?',
    renderAnswer: () => (
      <Text size="xl" align="left" color="#ffffff">
        If you want to produce your show using another app, feel free to do so!
        You can upload your own audio to Anchor directly from our website or
        mobile apps and still take advantage of our free hosting, monetization,
        and more.
      </Text>
    ),
  },
  {
    question: 'Still have questions?',
    renderAnswer: () => (
      <Text size="xl" align="left" color="#ffffff">
        Get in touch with us{' '}
        <LinkText
          to="https://anchorhq.typeform.com/to/QzuiVt"
          target="self"
          isInline
        >
          <Text size="xl" color="#ffffff" isInline isBold>
            here
          </Text>
        </LinkText>
        . We look forward to hearing from you!
      </Text>
    ),
  },
];

const quotes = [
  {
    podcastCoverartImageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/journey_to_manifesting_podcast_art.png',
    podcastCoverartImageRetinaUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/journey_to_manifesting_podcast_art@2x.png',
    authorName: 'Sarah Prout',
    podcastName: 'Journey to Manifesting',
    quote:
      "Anchor is the solution I've been waiting for! It removes so many steps in the podcast process and makes things super-easy. I am so thrilled with my choice to switch to Anchor.",
  },
  {
    podcastCoverartImageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/heartland_podcast_art.png',
    podcastCoverartImageRetinaUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/heartland_podcast_art@2x.png',
    authorName: 'Ty Schmitt',
    podcastName: 'Heartland Radio 2.0',
    quote:
      'The thing that really surprised me was how intuitive and easy to use the platform is. I searched all over the internet for something that lets me post a podcast quickly without jumping through hoops.',
  },
  {
    podcastCoverartImageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/ask_women_podcast_art.png',
    podcastCoverartImageRetinaUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/ask_women_podcast_art@2x.png',
    authorName: 'Marni Kinrys',
    podcastName: 'Ask Women Podcast',
    quote:
      'I’ve tried many other providers and they would charge me for every MB I loaded.  Anchor is free AND so easy to use AND great quality AND amazing customer service.  Why would I ever host my show anywhere else?',
  },
];

class ImportScreen extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      doShowConfirmOwnership: false,
      checkedOwnPodcast: false,
    };
  }

  handleBlurRssFeed = e => {
    const { onBlur } = this.props;
    if (e && e.currentTarget) {
      onBlur(e.currentTarget.value);
    }
  };

  handleClickLetsDoIt = e => {
    const { onShowOwnershipConfirmation } = this.props;
    this.setState(
      {
        doShowConfirmOwnership: true,
      },
      () => {
        onShowOwnershipConfirmation();
      }
    );
  };

  handleDismissConfirmOwnership = e => {
    this.setState({
      doShowConfirmOwnership: false,
    });
  };

  handleOwnPodcastCheckboxChange = e => {
    this.setState({ checkedOwnPodcast: e.target.checked });
  };

  render() {
    const {
      isSearching,
      rssTypeaheadResults,
      onTypeaheadSearch,
      onSelectTypeahead,
      onSubmit,
      fetchingRSSFeedImport,
      rssFeedUrl,
      rssFeedIsValid,
      rssFeedError,
      rssFeedMetadata,
    } = this.props;

    const { doShowConfirmOwnership, checkedOwnPodcast } = this.state;

    const hasDataToContinue =
      !fetchingRSSFeedImport && rssFeedMetadata && rssFeedMetadata.podcastName;

    // TODO (bui): remove inline styles
    return (
      <Box testId="ImportScreen">
        <Box testId="ImportScreen_search-section" color="#8940fa">
          <Box
            width="100%"
            display="flex"
            justifyContent="center"
            dangerouslySetInlineStyle={{
              background:
                'linear-gradient(345deg, rgba(0,0,0,0.1) 15%, rgba(0,0,0,0) 9%), linear-gradient(328deg, rgba(0,0,0,0) 95%, rgba(0,0,0,0.1) 93%)',
            }}
          >
            <Box
              testId="ImportScreen_search-section_content"
              maxWidth={1015}
              width="100%"
              paddingLeft={30}
              paddingRight={30}
            >
              <Box paddingBottom={20} paddingTop={76}>
                <Heading size="lg" color="#ffffff" align="center" isBold>
                  Switch your podcast to Anchor
                </Heading>
                <Box marginTop={10}>
                  <Text align="center" color="#ffffff" size="lg">
                    Free hosting, automatic distribution, easy monetization.
                  </Text>
                </Box>
              </Box>

              <ImportForm
                handleSubmit={() => {}}
                isSearching={isSearching}
                onSelectTypeahead={onSelectTypeahead}
                onTypeaheadSearch={onTypeaheadSearch}
                rssTypeaheadResults={rssTypeaheadResults}
                renderTypeaheadOption={option => {
                  const { image, podcastName, authorName } = option;
                  return (
                    <TypeaheadOption
                      image={image}
                      podcastName={podcastName}
                      authorName={authorName}
                    />
                  );
                }}
                rssFeedError={rssFeedError}
                hasDataToContinue={hasDataToContinue}
                fetchingRSSFeedImport={fetchingRSSFeedImport}
                rssFeedIsValid={rssFeedIsValid}
                onClickLetsDoIt={this.handleClickLetsDoIt}
                rssFeedMetadata={rssFeedMetadata}
                keepDirtyOnReinitialize
              />
            </Box>
          </Box>
        </Box>
        <ScreenSection
          color="#ebeced"
          bottomBorderSlope={90}
          bottomSlopDirection="down"
        >
          <Box
            testId="ImportScreen_example-podcasts-section"
            justifyContent="center"
            display="flex"
            paddingTop={104}
            paddingBottom={104}
            paddingLeft={30}
            paddingRight={30}
          >
            <Box
              testId="ImportScreen_example-podcasts-section_content"
              maxWidth={900}
            >
              <Box marginBottom={18}>
                <Heading size="md" align="center" isBold>
                  Anchor powers 1 in 3 of all new podcasts created in the world
                </Heading>
              </Box>
              <SizeMe>
                {({ size: { width } }) => {
                  const isMobile = width <= 768;
                  const imageType = isMobile ? 'mobile' : 'desktop';
                  return (
                    <Image
                      imageUrl={`ttps://d12xoj7p9moygp.cloudfront.net/images/screens/import/notable_podcasts_${imageType}.png`}
                      retinaImageUrl={`https://d12xoj7p9moygp.cloudfront.net/images/screens/import/notable_podcasts_${imageType}@2x.png`}
                      width="100%"
                    />
                  );
                }}
              </SizeMe>
            </Box>
          </Box>
        </ScreenSection>
        <ScreenSection
          color=" #f4f4f5"
          bottomBorderSlope={90}
          bottomSlopDirection="up"
        >
          <Box
            testId="ImportScreen_why-switch-section"
            justifyContent="center"
            display="flex"
            paddingTop={100}
            paddingBottom={100}
            paddingLeft={30}
            paddingRight={30}
          >
            <Box
              testId="ImportScreen_why-switch-section_content"
              maxWidth={950}
              display="flex"
              justifyContent="around"
              alignItems="center"
              wrap
              width="100%"
            >
              <Box
                testId="ImportScreen_why-switch-section_bullet-section"
                maxWidth={450}
                width="100%"
              >
                <Box paddingTop={8} paddingBottom={8}>
                  <Heading size="md" isBold>
                    Why switch to Anchor?
                  </Heading>
                </Box>
                {valueProps.map(valueProp => (
                  <Box
                    key={valueProp}
                    paddingTop={8}
                    paddingBottom={8}
                    display="flex"
                    alignItems="center"
                  >
                    <Box width={12} height={12} marginRight={14}>
                      <Box
                        shape="circle"
                        color="#884af6"
                        width={8}
                        height={8}
                      />
                    </Box>
                    <Text size="lg" color="rgba(41, 47, 54, 0.6)">
                      {valueProp}
                    </Text>
                  </Box>
                ))}
              </Box>
              <Box
                testId="ImportScreen_why-switch-section_image-section"
                paddingTop={25}
                maxWidth={459}
              >
                <Image
                  imageUrl="https://d12xoj7p9moygp.cloudfront.net/images/screens/import/macbook_dashboard.png"
                  retinaImageUrl="https://d12xoj7p9moygp.cloudfront.net/images/screens/import/macbook_dashboard@2x.png"
                  width="100%"
                  // height={265}
                />
              </Box>
            </Box>
          </Box>
        </ScreenSection>
        <ScreenSection
          color="#f9f9f9"
          bottomBorderSlope={90}
          bottomSlopDirection="down"
        >
          <Box justifyContent="center" display="flex" paddingTop={100}>
            <iframe
              width="680"
              height="368"
              src="https://www.youtube.com/embed/dPA5BVe88nM"
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </Box>
          <Box
            testId="ImportScreen_how-switch-works-section"
            justifyContent="center"
            display="flex"
            paddingTop={64}
            paddingBottom={100}
          >
            <Box
              testId="ImportScreen_how-switch-works_content"
              maxWidth={1000}
              width="100%"
            >
              <Box paddingTop={8} paddingBottom={15}>
                <Heading size="md" align="center" isBold>
                  How switching works
                </Heading>
              </Box>
              <Box
                testId="ImportScreen_how-switch-works_steps"
                display="flex"
                justifyContent="around"
                wrap
              >
                {stepsToSwitch.map((step, index) => (
                  <Box
                    key={step.title}
                    width={230}
                    marginLeft={10}
                    marginRight={10}
                    marginTop={15}
                    marginBottom={15}
                  >
                    <Box
                      testId="ImportScreen_how-switch-works_step-icon-container"
                      display="flex"
                      justifyContent="center"
                      marginBottom={31}
                    >
                      <Image
                        imageUrl={step.imageUrl}
                        retinaImageUrl={step.retinaImageUrl}
                        width={100}
                        height={100}
                      />
                    </Box>
                    <Box marginBottom={8}>
                      <Heading size="xs" align="center" color="#292f36" isBold>
                        {`${index + 1}. ${step.title}`}
                      </Heading>
                    </Box>
                    <Box>
                      <Text
                        size="md"
                        align="center"
                        color="rgba(41, 47, 54, 0.6)"
                      >
                        {step.description}
                      </Text>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </ScreenSection>
        <ScreenSection color="#ebeced">
          <Box
            testId="ImportScreen_quotes-section"
            justifyContent="center"
            display="flex"
            paddingTop={100}
            paddingBottom={100}
            paddingLeft={30}
            paddingRight={30}
          >
            <Box testId="ImportScreen_quotes-section_content" maxWidth={966}>
              <Box paddingTop={8} paddingBottom={40}>
                <Heading size="md" align="center" color=" #292f36" isBold>
                  What other podcasters are saying about Anchor
                </Heading>
              </Box>
              <Box
                testId="ImportScreen_quotes-section_quotes"
                display="flex"
                justifyContent="around"
                alignItems="center"
                wrap
              >
                {quotes.map(quote => (
                  <Box
                    key={quote.authorName}
                    width={300}
                    color="#ffffff"
                    height={260}
                    marginLeft={11}
                    marginRight={11}
                    marginTop={13}
                    marginBottom={13}
                    padding={20}
                    shape="rounded"
                    display="flex"
                    justifyContent="between"
                    direction="column"
                    dangerouslySetInlineStyle={{
                      boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.1)',
                    }}
                  >
                    <Box
                      testId="quote-header-section"
                      display="flex"
                      alignItems="center"
                      marginBottom={21}
                      width="100%"
                    >
                      <Box
                        testId="quote-header-section_image-container"
                        width={50}
                      >
                        <Image
                          imageUrl={quote.podcastCoverartImageUrl}
                          retinaImageUrl={quote.podcastCoverartImageRetinaUrl}
                          width={50}
                          height={50}
                        />
                      </Box>
                      <Box
                        testId="quote-header-section_name-and-title-container"
                        paddingLeft={18}
                        width="100%"
                      >
                        <Text
                          size="lg"
                          align="left"
                          color="gray" // TODO: what should this color be?
                        >
                          {`${quote.authorName} from`}
                        </Text>
                        <Text size="lg" align="left" color="#292f36" isBold>
                          {quote.podcastName}
                        </Text>
                      </Box>
                    </Box>
                    <Box
                      testId="quote-section_quote"
                      width="100%"
                      minHeight={137}
                    >
                      <Text
                        size="lg"
                        align="left"
                        color="rgba(41, 47, 54, 0.6)"
                      >
                        {quote.quote}
                      </Text>
                    </Box>
                    <Box
                      width="100%"
                      testId="quote-section_quote-icon-section"
                      display="flex"
                      justifyContent="end"
                    >
                      <Box
                        testId="quote-section_quote-icon-section_icon"
                        width={34}
                      >
                        <Icon type="quote" fillColor="#8940fa" />
                      </Box>
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </ScreenSection>
        <ScreenSection color="#8940fa">
          <Box testId="ImportScreen_faq-section">
            <Box
              justifyContent="center"
              display="flex"
              paddingTop={70}
              paddingBottom={70}
              paddingLeft={30}
              paddingRight={30}
              dangerouslySetInlineStyle={{
                background:
                  'linear-gradient(321deg, rgba(0, 0, 0, 0.1) 2%, rgba(0, 0, 0, 0) -3%), linear-gradient(335deg, rgba(0, 0, 0, 0) 89%, rgba(0, 0, 0, 0.2) 84%), linear-gradient(326deg, rgba(0, 0, 0, 0) 97%, rgba(0, 0, 0, 0.2) 93%)',
              }}
            >
              <Box testId="ImportScreen_faw-section_content" maxWidth={780}>
                <Box paddingTop={8} paddingBottom={8} marginBottom={37}>
                  <Heading size="md" align="center" color="#ffffff" isBold>
                    Anchor FAQs
                  </Heading>
                </Box>
                <Box>
                  {faqs.map(faq => (
                    <Box>
                      <Box paddingTop={8} paddingBottom={8}>
                        <Heading size="sm" align="left" color="#ffffff" isBold>
                          {faq.question}
                        </Heading>
                      </Box>
                      <Box paddingTop={8} paddingBottom={8} marginBottom={20}>
                        {faq.renderAnswer()}
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          </Box>
        </ScreenSection>
        <Footer />

        <ConfirmationModal
          isShowing={doShowConfirmOwnership}
          onHide={this.handleDismissConfirmOwnership}
          onToggleOwnershipCheckbox={this.handleOwnPodcastCheckboxChange}
          isOwnershipChecked={checkedOwnPodcast}
          rssFeedMetadata={rssFeedMetadata}
          rssFeedUrl={rssFeedUrl}
          onSubmit={rssFeedUrl => {
            onSubmit(rssFeedUrl);
          }}
        />
      </Box>
    );
  }
}

ImportScreen.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onShowOwnershipConfirmation: PropTypes.func.isRequired,
  isSearching: PropTypes.bool.isRequired,
  onSelectTypeahead: PropTypes.arrayOf(
    PropTypes.shape({
      feedUrl: PropTypes.string.isRequired,
      podcastName: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  onTypeaheadSearch: PropTypes.func.isRequired,
  rssTypeaheadResults: PropTypes.arrayOf(
    PropTypes.shape({
      podcastName: PropTypes.string.isRequired,
      podcastDescription: PropTypes.string.isRequired,
      authorName: PropTypes.string.isRequired,
      episodeCount: PropTypes.number.isRequired,
      image: PropTypes.string.isRequired,
      feedUrl: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  rssFeedError: PropTypes.shape({
    message: PropTypes.string.isRequired,
  }).isRequired,
  fetchingRSSFeedImport: PropTypes.bool.isRequired,
  rssFeedIsValid: PropTypes.bool.isRequired,
  rssFeedMetadata: PropTypes.shape({
    authorName: PropTypes.string.isRequired,
    authorEmail: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    isExplicit: PropTypes.bool.isRequired,
    itunesCategory: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
    podcastName: PropTypes.string.isRequired,
    podcastDescription: PropTypes.string.isRequired,
    episodeCount: PropTypes.number.isRequired,
  }).isRequired,
  rssFeedUrl: PropTypes.string.isRequired,
};

export default ImportScreen;
